import { Component, h, Prop } from '@stencil/core';
import { ValueOfIconUIType } from './icon-ui-type';

@Component({
    tag: 'web-icon',
    shadow: false
})
export class MyIcon {
    /**
     * The name used to select which icon to display
     */
    @Prop() name: ValueOfIconUIType;

    /**
     * The title of the icon.
     * This is used for accessibility and to provide a tooltip for the icon.
     * Use this when no other context is available.
     */
    @Prop() iconTitle: string;

    /**
     * The location / folder of the SVG Sprite.
     * Ensure that the icon you intend to use is present in the 'icon/ui' folder, which is located within the 'foundation' directory of the design-system.
     */
    @Prop() location = '/assets/icons/ui';

    render = () =>
        this.name ? (
            <svg fill="currentColor" role="presentation" focusable="false">
                {this.iconTitle && <title>{this.iconTitle}</title>}
                <use href={`${this.location}/${this.name}.svg#${this.name}`} />
            </svg>
        ) : (
            ''
        );
}
